"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _center = _interopRequireDefault(require("@turf/center"));

var _circle = _interopRequireDefault(require("@turf/circle"));

var _distance = _interopRequireDefault(require("@turf/distance"));

var _editingMode = _interopRequireDefault(require("./editing-mode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EditingMode = /*#__PURE__*/function (_ReactMapGlEditingMod) {
  _inherits(EditingMode, _ReactMapGlEditingMod);

  var _super = _createSuper(EditingMode);

  function EditingMode() {
    _classCallCheck(this, EditingMode);

    return _super.apply(this, arguments);
  }

  _createClass(EditingMode, [{
    key: "_updateFeature",
    value: function _updateFeature(props, type, options) {
      var data = props.data,
          selectedIndexes = props.selectedIndexes;
      var featureIndex = selectedIndexes && selectedIndexes[0];
      var feature = this.getSelectedFeature(props, featureIndex);

      if (type === 'editHandle' && feature.properties.shape === 'Circle') {
        var center = (0, _center["default"])(feature);
        var newCircle = (0, _circle["default"])(center, (0, _distance["default"])(center, options.mapCoords));

        var updatedFeature = _objectSpread(_objectSpread({}, data.features[featureIndex]), {}, {
          geometry: newCircle.geometry
        });

        var updatedFeatureCollection = _objectSpread(_objectSpread({}, data), {}, {
          features: [].concat(_toConsumableArray(data.features.slice(0, featureIndex)), [updatedFeature], _toConsumableArray(data.features.slice(featureIndex + 1)))
        });

        return updatedFeatureCollection;
      }

      return _get(_getPrototypeOf(EditingMode.prototype), "_updateFeature", this).call(this, props, type, options);
    }
  }, {
    key: "handleStopDragging",
    value: function handleStopDragging(event, modeProps) {
      var onEdit = modeProps.onEdit,
          data = modeProps.data;
      var picks = event.picks,
          isDragging = event.isDragging;
      var editType = isDragging ? 'movePosition' : 'finishMovePosition';
      var _picks$ = picks[0],
          object = _picks$.object,
          featureIndex = _picks$.featureIndex;
      var feature = data.features[featureIndex];
      var updatedData = data;

      if (feature.properties.shape === 'Circle' && object.properties.guideType === 'editHandle') {
        var newCircle = (0, _circle["default"])((0, _center["default"])(feature), (0, _distance["default"])((0, _center["default"])(feature), (0, _center["default"])(object)));

        var updatedFeature = _objectSpread(_objectSpread({}, data.features[featureIndex]), {}, {
          geometry: newCircle.geometry
        });

        var updatedFeatureCollection = _objectSpread(_objectSpread({}, data), {}, {
          features: [].concat(_toConsumableArray(data.features.slice(0, featureIndex)), [updatedFeature], _toConsumableArray(data.features.slice(featureIndex + 1)))
        });

        updatedData = updatedFeatureCollection;
      }

      onEdit({
        editType: editType,
        updatedData: updatedData,
        editContext: null
      });
    }
  }]);

  return EditingMode;
}(_editingMode["default"]);

var _default = EditingMode;
exports["default"] = _default;